module.exports = __webpack_public_path__ + "static/media/pendingRequest.0f638d90.svg";